import React, {useEffect, useState} from 'react';
import Layout from './layout';
import StatusView from './status-view';
import ContractStatusGraph from "./contract-status-graph";
import ProcessContractModel from "../models/process-contract";
import ProcessModel from "../models/process";
import FullScreenLoader from "./full-screen";
import SelectBlockchain from "./select-blockchains";
import EmptyView from "./empty-view";
import SandraJsAPI from "../services/sandraJsAPI";
import Web3Nova from "../services/web3Nova";
import IStatusMessage from "../models/status-message";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

;

function ContractStatus(): React.ReactElement {
    const emptyStatus: IStatusMessage = {message: '', type: StatusMessageTypeEnum.none}
    const [statusMessage, setStatusMessage] = useState(emptyStatus);
    const [isLoading, setIsLoading] = useState(true);
    const [blockchain, setBlockchain] = useState('');
    const [latestBlockNumber, setLatestBlockNumber] = useState(0);
    const processInit: ProcessModel = {
        addresses: [],
        status: '',
        blockchain: '',
        appName: '',
        id: '',
        processID: "",
        processDescription: '',
        processTitle: '',
        lastStopTime: '',
        lastStartTime: '',
        monitor: {
            memory: 0,
            cpu: 0
        }
    };
    const [process, setProcess] = useState(processInit);

    function getLatestBlockNumber(chain: string) {
        const web3 = new Web3Nova(chain);
        web3.getLatestBlockNumber().then(
            (blockNumber) => {
                setLatestBlockNumber(blockNumber);
            },
        ).catch((reason) => {
            console.log(reason.message);
        });
    }

    useEffect(() => {
        setIsLoading(true);
        if (blockchain) {
            getLatestBlockNumber(blockchain);
            SandraJsAPI.getContractStatuses(blockchain)
                .then((process) => {
                    setIsLoading(false);
                    setProcess(process.data);
                })
                .catch((reason) => {
                    setIsLoading(false);
                    setStatusMessage({message: reason.message, type: StatusMessageTypeEnum.error});
                });
        }
    }, [blockchain]);

    return (
        <Layout className="page contract-status ">
            <StatusView status={statusMessage}/>
            <div className="rounded mb-5 mt-3 loading-wrapper">
                {isLoading ? <FullScreenLoader/> : <div/>}
                <div className="d=block clear">
                    <h5 className="d-inline-block text-uppercase pt-2 ps-1 pb-3 ">Jetski Contract Status</h5>
                    <div className="d-inline-block mb-3 float-end">
                        <SelectBlockchain
                            balor={false}
                            onLoading={() => {
                                setIsLoading(true);
                            }}
                            onLoaded={() => {
                            }}
                            onChange={(data) => {
                                setBlockchain(data);
                            }}
                            setStatusMessage={(message, type) => {
                                setStatusMessage({message, type});
                            }}
                        />
                    </div>
                </div>
                <div className="d-block">
                    {
                        process?.addresses?.length > 0
                            ?
                            (
                                process?.addresses?.map((contract: ProcessContractModel) => (
                                    <ContractStatusGraph contract={contract}
                                                         currentBlock={latestBlockNumber}/>
                                ))
                            )
                            :
                            <EmptyView title={"Contracts not found"} desc={""}/>
                    }
                </div>
            </div>
            <div/>
        </Layout>
    );
}

export default ContractStatus;
